import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {PushNotificationsView} from "../../components/pushNotification/PushNotificationsView";

const PushNotifications: NextPage = () => {
  return <>
    <Head>
      <title>Push Notifications</title>
    </Head>
    <PushNotificationsView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate']),
    }
  }
});


export default PushNotifications